<template>
  <div class="frame welcome">
    <div class="center">
      <div class="title">WELCOME</div>
      <div class="desc">欢迎使用成旅聘通人才库！</div>
      <img src="../assets/welcome.jpeg" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: "welcome",
  components: {},
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.welcome {
  height: calc(100% - 40px);
  position: relative;
}
.center {
  width: 100%;
  text-align: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  &::before {
    content: "";
    display: table;
  }

  .title {
    font-size: 60px;
    letter-spacing: 5px;
    color: #eeeff2;
    position: absolute;
    left: 50%;
    top: 25px;
    transform: translate(-50%, 0);
  }
  .desc {
    max-width: 80%;
    margin: 70px auto 0;
    font-size: 40px;
    font-weight: bold;
    position: relative;
    z-index: 2;
  }
  img {
    height: 55vh;
    margin: 30px 0 30px;
  }
}
</style>
